import React from 'react'
import PropTypes from 'prop-types'
import Grid from '@mui/material/Grid2'
import { Card, Typography, MenuItem, TextField } from '@mui/material'
import LineChart from '../Helpers/LineChart'

const OrdersChart = ({ ordersData, totalSalesChart, ordersChartOption, classes, handleOrderChartChange, storeCurrency }) => {
  let totalOrders = 0
  ordersData.forEach((orderData) => (totalOrders += parseInt(orderData.y)))
  return (
    <Card elevation={3} sx={classes.ordersChartCard}>
      <Grid container>
        <Grid container sx={classes.ordersChartContainer} size={12} alignItems="center">
        <Grid size={9}>
          <Typography variant='h5' color="textPrimary">Total Orders</Typography>
          <Typography variant='h5' color="textSecondary">{totalOrders}</Typography>
        </Grid>
          <Grid size={3} textAlign="right">
          <Typography variant='h6' color="textSecondary">
            Total Sales: {totalSalesChart} {storeCurrency.symbol}
          </Typography>
            <TextField
              value={ordersChartOption}
              variant='outlined'
              label="Duration"
              sx={{float: 'right', mt: 2}}
              onChange={handleOrderChartChange}
              inputProps={{
                sx: classes.ordersChartSelect
              }}
              select >
              <MenuItem value='7days'>Last 7 days</MenuItem>
              <MenuItem value='last-month'>Last Month</MenuItem>
              <MenuItem value='last-year'>Last Year</MenuItem>
            </TextField>
          </Grid>
        </Grid>
        <Grid size={12}>
          <LineChart data={ordersData} seriesName="Orders" height="100%" title="ORDERS OVER TIME" />
        </Grid>
      </Grid>
    </Card>
  )
}

OrdersChart.propTypes = {
  ordersChartOption: PropTypes.string.isRequired,
  handleOrderChartChange: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  ordersData: PropTypes.array.isRequired
}
  
export default OrdersChart